<template>
	<v-main>
		<router-view />
	</v-main>
</template>

<script>
export default {
	components: {
		Loading: () => import("~/components/molecules/Loading"),
	},

	data() {
		return {
			isShowedLoading: false,
			requestPending: 0,
		};
	},

	methods: {
		handleLoader(value) {
			if (value) {
				this.requestPending += 1;
			} else {
				this.requestPending -= 1;
			}
			if (this.requestPending <= 0) {
				this.isShowedLoading = false;
				this.requestPending = 0;
			} else {
				this.isShowedLoading = true;
			}
		},
	},
};
</script>
